/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeRestrictionValidationData,
    DateTimeRestrictionValidationDataFromJSON,
    DateTimeRestrictionValidationDataFromJSONTyped,
    DateTimeRestrictionValidationDataToJSON,
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchRuleValidationData
 */
export interface SearchRuleValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchRuleValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchRuleValidationData
     */
    maxPriceSolutions?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchRuleValidationData
     */
    maxPricePoints?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchRuleValidationData
     */
    dateTimeRestrictionsTimeZone?: ValidationMessage;
    /**
     * 
     * @type {Array<DateTimeRestrictionValidationData>}
     * @memberof SearchRuleValidationData
     */
    readonly dateTimeRestrictions?: Array<DateTimeRestrictionValidationData> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof SearchRuleValidationData
     */
    readonly travelDates?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchRuleValidationData
     */
    brandAndMarket?: ValidationMessage;
}

export function SearchRuleValidationDataFromJSON(json: any): SearchRuleValidationData {
    return SearchRuleValidationDataFromJSONTyped(json, false);
}

export function SearchRuleValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : ValidationMessageFromJSON(json['maxPriceSolutions']),
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : ValidationMessageFromJSON(json['maxPricePoints']),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : ValidationMessageFromJSON(json['dateTimeRestrictionsTimeZone']),
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionValidationDataFromJSON)),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
    };
}

export function SearchRuleValidationDataToJSON(value?: SearchRuleValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'maxPriceSolutions': ValidationMessageToJSON(value.maxPriceSolutions),
        'maxPricePoints': ValidationMessageToJSON(value.maxPricePoints),
        'dateTimeRestrictionsTimeZone': ValidationMessageToJSON(value.dateTimeRestrictionsTimeZone),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
    };
}


